import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging"
import firebaseApp from "./config"

let messaging = null
const vapidKey = 'BJsNwrdj2cbmpnnxTCsobX8gDaF3AnvQTyo-ubQfZDCGRr-aZhT9LSHWawnrAWCy2T5uJF1Lc2u3FYif7bLeYiE'

export const requestNotificationPermission = async () => {
    try {
        const supported = await isSupported()
        if (!supported) {
            console.log("Firebase messaging not supported in this browser.")
            return null
        }
        if (!messaging) {
            messaging = getMessaging(firebaseApp)
        }
        const token = await getToken(messaging, { vapidKey })
        if (token) {
            // console.log(token)
            return token
        } else {
            console.log("No registration token available.")
        }
    } catch (error) {
        console.log("Error getting token:", error)
    }
}

export const onMessageListener = async () => {
    const supported = await isSupported()
    if (!supported) {
        return new Promise(() => {}) // never resolves
    }
    if (!messaging) {
        messaging = getMessaging(firebaseApp)
    }
    return new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload)
        })
    })
}
